/**
 * HOOK: useAssociations (VERSION REFACTORISÉE)
 * Utilise le hook useCRUD générique
 *
 * 🎯 Avant: 138 lignes | Après: 22 lignes | Réduction: 84%
 */

import type { Association, CreateAssociationDto, UpdateAssociationDto } from '../types/association';
import { useCRUD } from './useCRUD';

export function useAssociations() {
  const crud = useCRUD<Association, CreateAssociationDto, UpdateAssociationDto>('associations', {
    select: '*, crews:crews!association_id(count)',
    orderBy: { column: 'name', ascending: true },
  });

  return {
    // API spécifique (pour compatibilité)
    associations: crud.data,
    loading: crud.loading,
    error: crud.error,
    refreshAssociations: crud.refresh,
    getAssociationById: crud.getById,
    createAssociation: crud.create,
    updateAssociation: crud.update,
    deleteAssociation: crud.remove,
    deleteAssociations: crud.removeMany,

    // API générique (pour useEntityList)
    data: crud.data,
    create: crud.create,
    update: crud.update,
    remove: crud.remove,
    removeMany: crud.removeMany,
  };
}

/**
 * MIGRATION GUIDE:
 *
 * Ancien code:
 * const { associations, loading, error, createAssociation, updateAssociation, deleteAssociation } = useAssociations();
 *
 * Nouveau code:
 * const { data: associations, loading, error, create: createAssociation, update: updateAssociation, remove: deleteAssociation } = useAssociations();
 */
